<template>
  <div class="ca-file-preview">
    <template v-if="fileId">
      <el-tooltip :disabled="!truncated" :content="fileName" placement="top">
        <span ref="name" class="ca-file-preview__name">{{ fileName }}</span>
      </el-tooltip>
      <i class="el-icon-download ca-file-preview__icon" title="下载" @click="handleDownload" />
      <i class="el-icon-search ca-file-preview__icon" title="预览" @click="handlePreview" />
    </template>
    <span v-else class="ca-file-preview__empty">未上传</span>
  </div>
</template>

<script>
import { queryByFileId } from '@/api/upload'
import { download } from '@/shared/file'

/**
 * CA 附件只读展示（订单详情页用）。
 * 形态 = 文件名（单行省略，仅在真被截断时才挂 tooltip 显示全名）+ 右侧「下载」「预览」
 * 两个图标按钮；文件名左侧不展示任何文件类型图标（产品明确不要）。
 * fileId 为空时只显示灰色「未上传」，不渲染图标。
 *
 * 同名陷阱：全局组件目录下还有一个 '@/components/FilePreview/FilePreview.vue'，
 * 与本组件同名不同物。CA 页面内 import 必须写相对路径 '../components/FilePreview.vue'。
 */
export default {
  name: 'FilePreview',
  props: {
    fileId: { type: String, default: '' }, // 空串 = 未上传，显示占位文案
  },
  data() {
    return {
      fileName: '', // fileId 对应的原始文件名（queryByFileId 接口回显）
      truncated: false, // 文件名是否真被截断（scrollWidth > clientWidth），决定要不要挂 tooltip
    }
  },
  watch: {
    fileId: {
      immediate: true,
      handler(id) {
        this.fileName = ''
        if (!id) return
        queryByFileId({ fileId: id }).then((res) => {
          this.fileName = (res.data && res.data.fileName) || ''
          this.checkTruncation()
        })
      },
    },
  },
  methods: {
    checkTruncation() {
      this.$nextTick(() => {
        const el = this.$refs.name
        this.truncated = !!el && el.scrollWidth > el.clientWidth
      })
    },
    handleDownload() {
      download(this.fileId)
    },
    handlePreview() {
      window.open('/zcjf/base/file/download/' + this.fileId)
    },
  },
}
</script>
